import { ResponsibleMedicalRecordRepository } from '../../domain/repositories/ResponsibleMedicalRecordRepository'
import { ResponsibleMedicalRecordDatasource } from '../datasources/ResponsibleMedicalRecordDatasource'

export const responsibleMedicalRecordRepositoryAdapter = (
  responsibleMedicalRecordDatasource: ResponsibleMedicalRecordDatasource
): ResponsibleMedicalRecordRepository => ({
  getResponsibleMedicalRecord: async (params) =>
    await responsibleMedicalRecordDatasource.getResponsibleMedicalRecord(
      params
    ),
  updateResponsibleMedicalRecord: async (params) =>
    await responsibleMedicalRecordDatasource.updateResponsibleMedicalRecord(
      params
    ),
  setResponsibleMedicalRecordExpired: async (params) =>
    await responsibleMedicalRecordDatasource.setResponsibleMedicalRecordExpired(
      params
    ),
  setResponsibleMedicalRecordCompleted: async (params) =>
    await responsibleMedicalRecordDatasource.setResponsibleMedicalRecordCompleted(
      params
    ),
  createResponsibleMedicalRecordLink: async (params) =>
    await responsibleMedicalRecordDatasource.createResponsibleMedicalRecordLink(
      params
    ),
  listResponsibleMedicalRecord: async (params) =>
    await responsibleMedicalRecordDatasource.listResponsibleMedicalRecord(
      params
    ),
  getResponsibleMedicalRecordForReview: async (params) =>
    await responsibleMedicalRecordDatasource.getResponsibleMedicalRecordForReview(
      params
    ),
  getResponsibleMedicalRecordForView: async (params) =>
    await responsibleMedicalRecordDatasource.getResponsibleMedicalRecordForView(
      params
    ),
  reviewResponsibleMedicalRecord: async (params) =>
    await responsibleMedicalRecordDatasource.reviewResponsibleMedicalRecord(
      params
    )
})
